import React from "react";

interface Props {
  className?: string;
  children: string;
  contentLength?: number;
}

/**
 * Surround a string container markup to parse it as markup.
 * Be aware that using this has the potential for script injection attacks.
 * ONLY USE ON CONTENT FROM TRUSTED SOURCES
 * @param className
 * @param contentLength
 * @param children
 * @param rest
 */
export default ({
  className = "",
  contentLength = 250,
  children,
  ...rest
}: Props) => {
  const content = children
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
    .substring(0, contentLength);

  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
      {...rest}
    />
  );
};
